import controller from './search-appointment.controller';
import template from './search-appointment.html';

const searchApointmentComponent = {
	bindings: {
		doctorListFilter: '<',
		doctorList: '<',
		selectedPage: '<',
		elementsForPage: '<',
		language: '<'
	},
	controller,
	template,
};

export default searchApointmentComponent;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/search-appointment/search-appointment.component.js